import { BaseWithId } from '@app/shared/models/base';
import { DisplayName } from '@app/shared/components/select/base-select-with-id.component';
import { DrFileMetaList } from '@app/shared/models/dr-file';

export class ClaimType extends BaseWithId
                       implements DisplayName {
    public client_id: string;
    public name: string;
    public sort_order: number;
    public instructions: DrFileMetaList;

    get displayName(): string {
        return this.name;
    }

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            instructions: new DrFileMetaList({
                document_type: json && json.id || null,
                entries: json && json.instructions || []
            })
        });
    }
}
